<script>
    import R, {LOADER} from "../lib/requests";
    import {API_URL, CUSTOMER_TYPE, CUSTOMER_TYPES, PAYMENT_TYPE, PAYMENT_TYPES} from "../lib/constants";
    import {lastDateOfMonth} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import DateControl from "../components/controls/DateControl.svelte";
    import MultiSelectControl from "../components/controls/MultiSelectControl.svelte";

    export let accounts = null;

    const pageHeaderControls = [
        {id: 'export', name: 'EXPORT', icon: 'file-excel'},
    ];

    let search = {
        date_from: null,// '2024-01-01',
        date_to: null,// getDate('y-m-d'),
        account_id: '',
        hotel_id: [],
        customer_type: [CUSTOMER_TYPE.COMPANY],
        payment_type: [PAYMENT_TYPE.ON_ACCOUNT]
    }
    let hotels = [];
    let paymentTypes = [];
    let customerTypes = [];
    let report = null;

    // const initialize = () => {
    //     const onSuccess = result => {
    //         accounts = result;
    //     }
    //
    //     const onFailure = err => {
    //     };
    //
    //     R.handle(R.account.index, {}, onSuccess, onFailure, LOADER.PAGE);
    // }

    const validate = () => {
        if (!search.date_from || !search.date_to) {
            Notifier.showError("Select dates for the report!");
            return;
        }

        if (!search.account_id) {
            Notifier.showError("Select account for the report!");
            return;
        }

        if (!search.customer_type.length) {
            Notifier.showError("Select customer types for the report!");
            return;
        }

        if (!search.payment_type.length) {
            Notifier.showError("Select payment types for the report!");
            return;
        }

        return true;
    }

    const load = () => {
        const onSuccess = result => {
            report = result;
        }

        const onFailure = err => {
        };

        if (!validate()) {
            return;
        }

        R.handle(R.report.account, search, onSuccess, onFailure, LOADER.POPUP);
    }

    const onDateFromChange = () => {
        if (!search.date_from) {
            return;
        }

        if (!search.date_to || search.date_to < search.date_from) {
            search.date_to = lastDateOfMonth(search.date_from);
        }
    }

    const onAccountChange = () => {
        console.log("onAccountChange", search.account_id);

        search.hotel_id = '';
        hotels = [];

        if (!search.account_id) {
            return;
        }

        let item = accounts.find(x => x.id == search.account_id);
        if (item) {
            hotels = item.hotels;
        }
    }

    // const onSearch = () => {
    //     if (!search.date_from || !search.date_to) {
    //         return;
    //     }
    //     if (search.account_id) {
    //         load();
    //     }
    // }

    const onOpenTransfer = id => {
        window.open(`/app/transfer/${id}`, "_blank");
    }

    const onExport = () => {
        if (!validate()) {
            return;
        }

        const extra = `?report=account&` + new URLSearchParams(search);
        console.log(API_URL + '/export.php' + extra);
        window.open(API_URL + '/export.php' + extra);
    }

    // init payment types
    Object.keys(PAYMENT_TYPE).map(key => {
        paymentTypes.push({
            id: PAYMENT_TYPE[key],
            name: PAYMENT_TYPES[PAYMENT_TYPE[key]],
            is_checked: search.payment_type.indexOf( PAYMENT_TYPE[key]) > -1 ? 1 : 0,
        });
    });

    // init customer types
    Object.keys(CUSTOMER_TYPE).map(key => {
        customerTypes.push({
            id: CUSTOMER_TYPE[key],
            name: CUSTOMER_TYPES[CUSTOMER_TYPE[key]],
            is_checked: search.customer_type.indexOf( CUSTOMER_TYPE[key]) > -1 ? 1 : 0,
        });
    });

    // initialize();
</script>
<PageHeader title="Account Report" controls={ pageHeaderControls } on:export={ onExport }/>

{#if accounts}
    <div class="panel-simple p-2 mb-4">
        <div class="row">
            <div class="col-lg-1 col-sm-3 col-6">
                <DateControl bind:value="{ search.date_from }" placeholder="from" on:change={ onDateFromChange }/>
            </div>
            <div class="col-lg-1 col-sm-3 col-6 form-group-sm">
                <DateControl bind:value="{ search.date_to }" placeholder="to"/>
            </div>
            <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
                <select class="form-select" bind:value="{ search.account_id }" on:change={ onAccountChange }>
                    <option value="">account</option>
                    {#each accounts as item}
                        <option value="{ item.id }">{ item.name }</option>
                    {/each}
                </select>
            </div>
            <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
                <MultiSelectControl options="{ hotels }" bind:value="{ search.hotel_id }" placeholder="hotel"/>
            </div>
            <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
                <MultiSelectControl options="{ customerTypes }" bind:value="{ search.customer_type }" placeholder="customer type"/>
            </div>
            <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
                <MultiSelectControl options="{ paymentTypes }" bind:value="{ search.payment_type }" placeholder="payment type"/>
            </div>
            <div class="col-xl-2 col-sm-3 col-12">
                <button class="btn btn-primary btn-block" on:click={ load }>REPORT</button>
            </div>
        </div>
    </div>
{/if}

{#if report}
    <table class="table table-list table-list-border trans-account-hotels mb-5">
        <thead>
        <tr>
            <th colspan="9">
                Period: <b>{ report.period }</b><br>
                Account: <b>{ report.account }</b><br>
                Customer: <b>{ report.customer_type }</b><br>
                Payment Type: <b>{ report.payment_type }</b>
            </th>
        </tr>
        </thead>
        <tbody>
        {#if report.hotels.length}
            {#each report.hotels as hotel}
                <tr>
                    <td colspan="9" class="row-separator"></td>
                </tr>
                <tr>
                    <th colspan="9"><b>{ hotel.name }</b></th>
                </tr>
                <tr>
                    <th>DATE</th>
                    <th>TIME</th>
                    <th>KIND</th>
                    <th>V.TYPE</th>
                    <th>GUEST</th>
                    <th>ROOM/FLIGHT</th>
                    <th class="text-center">CHARGE</th>
                    <th colspan="2">NOTES</th>
                </tr>
                {#each hotel.transfers as transfer}
                    <tr>
                        <td>
                            <span class="is-link" on:click={ () => onOpenTransfer(transfer.id) }>
                                { transfer.date }
                            </span>
                        </td>
                        <td>{ transfer.time }</td>
                        <td>{ transfer.route_type }</td>
                        <td>{@html transfer.vehicles.join("<br>") }</td>
                        <td>{ transfer.customer }</td>
                        <td>{ transfer.room_flight }</td>
                        <td class="text-center">{ transfer.price }</td>
                        <td colspan="2">{ transfer.notes }</td>
                    </tr>
                {/each}
                <tr>
                    <th colspan="6">Sub Total</th>
                    <th class="text-center">Total</th>
                    <th class="text-center">Vat</th>
                    <th class="text-center">Net</th>
                </tr>
                <tr>
                    <td colspan="6"></td>
                    <td class="text-center">{ hotel.total_price }</td>
                    <td class="text-center">{ hotel.total_vat }</td>
                    <td class="text-center">{ hotel.total_net }</td>
                </tr>
            {/each}
            <tr>
                <td colspan="9" class="row-separator" style="height: 20px;"></td>
            </tr>
            <tr>
                <th colspan="6">Grand Total</th>
                <th class="text-center">Total</th>
                <th class="text-center">Vat</th>
                <th class="text-center">Net</th>
            </tr>
            <tr>
                <td colspan="6"></td>
                <td class="text-center">{ report.total_price }</td>
                <td class="text-center">{ report.total_vat }</td>
                <td class="text-center">{ report.total_net }</td>
            </tr>
        {:else}
            <tr>
                <td colspan="7">Nothing found!</td>
            </tr>
        {/if}
        </tbody>
    </table>
{/if}

<style>
    .trans-account-hotels .row-separator {
        height: 10px;
        padding: 0;
        background: #f2f6f8;
        /*border-left-color: #f2f6f8;*/
        /*border-right-color: #f2f6f8;*/
    }
</style>